<!-- 尖货弹窗 -->
<template>
  <z-action-picker
    v-model="showPopup"
    show-close
    :btn-text="btnText"
    :title="topGoodInfo.title"
    @confirm="closePopup"
  >
    <div class="action-content">
      {{ topGoodInfo.showText }}
    </div>
  </z-action-picker>
</template>

<script>
import Vue from 'vue'
import { defineComponent, watch, ref } from '@vue/composition-api'
import { ActionPicker } from '@zz-common/zz-ui'
import { skipToUrl } from '@utils/native'
Vue.use(ActionPicker)

export default defineComponent({
  components: {},
  props: {
    topGoodInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, ctx) {
    const { $legoSend } = ctx.root
    const btnText = ref('') // 按钮文案 默认我知道了
    const showPopup = ref(false)
    const closePopup = () => {
      const targetUrl = props.topGoodInfo.jumpUrl
      if (targetUrl) {
        targetUrl &&
          skipToUrl({
            targetUrl
          })
      } else {
        showPopup.value = !showPopup.value
      }
    }

    watch(
      () => props.topGoodInfo,
      () => {
        btnText.value = props.topGoodInfo.jumpUrl ? props.topGoodInfo.btnName : '我知道了'
      },
      {
        deep: true,
        immediate: true
      }
    )

    watch(
      () => showPopup.value,
      (val) => {
        if (val) {
          $legoSend({
            pagetype: 'Areaexposure',
            actiontype: 'T2974',
            backup: {
              sectionId: 144
            }
          })
        }
      }
    )

    const popupStatus = () => {
      showPopup.value = !showPopup.value
    }

    return { showPopup, popupStatus, closePopup, btnText }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';

.header {
  position: relative;
  z-index: -1;
  width: 100%;
  height: 194px;
  background: url('https://pic3.zhuanstatic.com/zhuanzh/e5e0db47-96eb-41f9-8399-2dd2caff9f96.png')
    no-repeat;
  background-size: 100% 194px;
  .title {
    position: relative;
    z-index: 3;
    display: inline-block;
    width: 100%;
    padding-top: 72px;
    color: #111;
    font-weight: 500;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 40px;
    text-align: center;
  }
}

.action-content {
  box-sizing: border-box;
  // margin-top: -40px;
  padding: 0 32px 80px;
  color: #111;
  font-weight: 300;
  font-size: 26px;
  font-family: PingFangSC-Light, PingFang SC;
  line-height: 40px;
}
</style>
